import { render } from "./ProjectRolePermissionTab.vue?vue&type=template&id=110f42bc&scoped=true"
import script from "./ProjectRolePermissionTab.vue?vue&type=script&lang=js"
export * from "./ProjectRolePermissionTab.vue?vue&type=script&lang=js"

import "./ProjectRolePermissionTab.vue?vue&type=style&index=0&id=110f42bc&lang=scss&scoped=true"
import "./ProjectRolePermissionTab.vue?vue&type=style&index=1&id=110f42bc&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.23.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-110f42bc"]])

export default __exports__